<template>
  <div class="sidebar" :class="{ collapsed: collapse }">
    <div class="logo">
      <span>DCMDAO管理后台</span>
    </div>
    <el-menu
        :default-active="activeMenu"
        class="sidebar-menu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        router
        unique-opened
        :collapse="collapse"
        :collapse-transition="false"
    >
      <el-menu-item index="/dashboard">
        <i class="el-icon-s-home"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-submenu index="user">
        <template slot="title">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </template>
        <el-menu-item index="/users/user">
          <i class="el-icon-search"></i>
          <span>用户</span>
        </el-menu-item>
        <el-menu-item index="/users/import/list">
          <i class="el-icon-upload"></i>
          <span>导入节点邀请码</span>
        </el-menu-item>
<!--        <el-menu-item index="/invite/index">
          <i class="el-icon-connection"></i>
          <span>邀请码</span>
        </el-menu-item>-->
<!--        <el-menu-item index="/users/add">
          <i class="el-icon-circle-plus"></i>
          <span>添加用户</span>
        </el-menu-item>-->
<!--        <el-menu-item index="/users/password">
          <i class="el-icon-key"></i>
          <span>修改密码</span>
        </el-menu-item>-->
      </el-submenu>
    </el-menu>
    <!-- [新增] 折叠/展开按钮（大屏显示） -->
    <div class="collapse-btn" @click="toggleCollapse" v-if="showToggleBtn">
      <i :class="collapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  computed: {
    activeMenu() {
      return this.$route.path
    }
  },
  props: {
    collapse: {           // [新增] 接收父组件传递的折叠状态
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // ...
      screenWidth: window.innerWidth,
      showToggleBtn: true  // [新增] 是否显示折叠按钮
    }
  },
  created() {
    // ...
    this.checkScreen()     // [新增] 初始化按钮显隐
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    // ...
    toggleCollapse() {     // [新增] 触发父组件的切换事件
      this.$emit('toggle-collapse')
    },
    checkScreen() {        // [新增] 根据宽度控制按钮显隐（≥992px 显示）
      this.screenWidth = window.innerWidth
      this.showToggleBtn = this.screenWidth >= 992
    },
    handleResize() {
      this.checkScreen()
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 220px;
  height: 100vh;
  background: #304156;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  transition: width 0.3s;
  position: relative;
}
/* [修改] 折叠时宽度变为 64px */
.sidebar.collapsed {
  width: 64px;
}
.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  background: #2b3a4d;
  border-bottom: 1px solid #1f2d3d;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.3s;
}
/* [新增] 折叠时隐藏文字 */
.sidebar.collapsed .logo span {
  opacity: 0;
  width: 0;
}
.sidebar-menu {
  flex: 1;
  border-right: none;
  overflow-y: auto;
}
.sidebar-menu:not(.el-menu--collapse) {
  width: 220px;
}
/* [新增] 折叠按钮样式 */
.collapse-btn {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bfcbd9;
  cursor: pointer;
  border-top: 1px solid #1f2d3d;
  font-size: 20px;
  flex-shrink: 0;
}
.collapse-btn:hover {
  background: #2b3a4d;
  color: #fff;
}
/* [新增] 小屏幕下隐藏折叠按钮 */
@media screen and (max-width: 991px) {
  .collapse-btn {
    display: none;
  }
}
</style>
